<template>
  <div>
    <b-list-group flush class="mb-2 cust-overflow-y h-full">
      <!-- <b-list-group-item action class="cursor-pointer">
        <b-row align-v="center">
          <b-col md="auto" class="pl-0">
            <div
              class="
                rounded-full
                w-10
                h-10
                flex
                justify-center
                items-center
                bg-primary-tranparent
              "
            >
              <img
                src="https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg"
                class="w-10 h-10 rounded-full"
              />
            </div>
          </b-col>
          <b-col class="pl-0">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4 class="mb-0 text-sm font-semibold">Caregiver Saathi</h4>
                <p class="text-xs text-muted font-normal mb-0">
                  #Brained-suite
                </p>
              </div>
              <base-button size="sm" type="primary">Join</base-button>
            </div>
          </b-col>
        </b-row>
      </b-list-group-item> -->
      <b-list-group-item
        action
        class="cursor-pointer chnl-left-cust-bg"
        v-for="channel in filteredList"
        :key="channel._id"
        :active="selectedChannel && selectedChannel._id === channel._id"
      >
        <b-row class="pl-2">
          <div
            class="rounded-full w-10 h-10 flex justify-center items-center bg-primary-tranparent"
          >
            <img
              :src="channelImage(channel)"
              class="w-10 h-10 rounded-full object-cover"
            />
          </div>
          <b-col class="pl-2">
            <div class="justify-content-between align-items-center">
              <div>
                <div class="items-cener">
                  <div class="d-flex justify-between items-center">
                    <h4 class="mb-0 md:mr-3 lg:mr-0 text-sm font-semibold">
                      {{ channel.name }}
                    </h4>
                  </div>
                  <!-- <b-badge
                    pill
                    variant="primary"
                    class="px-2 lh0px flex items-center"
                    >Private</b-badge
                  > -->

                  <p class="text-xs font-bold flex items-center clr00adc0">
                    {{ channel.type == "public" ? "Public" : "Private" }}
                  </p>
                  <p
                    v-if="channel.planId.length > 0"
                    class="text-xs font-normal flex items-center clr00adc0"
                  >
                    {{ channel.planId[0].name }}
                  </p>
                  <p
                    v-if="channel.planId.length == 0"
                    class="text-xs font-normal flex items-center clr00adc0"
                  >
                    {{ channel.type == "public" ? "Free" : "Invalid plan" }}
                  </p>
                </div>
                <p class="text-xs text-muted font-normal mb-2 ellipsis-2">
                  {{ channel.description }}
                </p>
              </div>
              <div>
                <b-badge variant="info" v-if="channel.isJoined"
                  >Request Sent</b-badge
                >
                <JoinChannel
                  v-else-if="!channel.isMember"
                  :user="user"
                  :channel="channel"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import JoinChannel from "./JoinChannel2";
export default {
  components: {
    JoinChannel,
  },
  computed: {
    ...mapState("channel", {
      selectedChannel: "selectedChannel",
      search: "search",
    }),
    ...mapGetters("channel", {
      ChannelList: "nonMemberChannels",
    }),
    ...mapState("auth", {
      user: "user",
    }),
    filteredList() {
      return this.ChannelList.filter((ChannelList) =>
        ChannelList.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    channelImage(channel) {
      return `${this.$imageURL}/${channel.picture}`;
    },
  },
};
</script>
<style>
.w-45px {
  width: 59px;
}
</style>
